import React from 'react';
import { Link } from 'react-router-dom';
import TopNav from './TopNav';
import Footer from './Footer';

const VideographyPage = () => {
  return (
    <div className="videography-page">
      <TopNav />
      <div className="videography-container">
        <Link to="/media" className="back-link">← Back to Media</Link>
        
        <div className="coming-soon-content">
          <span className="coming-soon-icon">🎬</span>
          <h1 className="page-title">Videography</h1>
          <p className="coming-soon-text">Coming Soon</p>
          <p className="coming-soon-description">
            Motion pictures and visual stories are on the way.
          </p>
        </div>
        
        <Footer />
      </div>

      <style jsx>{`
        .videography-page {
          min-height: 100vh;
          background: #151312;
          padding: 40px 20px;
        }

        .videography-container {
          max-width: 800px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          min-height: calc(100vh - 80px);
        }

        .back-link {
          font-family: 'Poppins', sans-serif;
          font-size: 14px;
          color: #f46c38;
          text-decoration: none;
          margin-bottom: 40px;
          transition: opacity 0.2s ease;
        }

        .back-link:hover {
          opacity: 0.8;
        }

        .coming-soon-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
        }

        .coming-soon-icon {
          font-size: 80px;
          margin-bottom: 24px;
        }

        .page-title {
          font-family: 'Poppins', sans-serif;
          font-size: 48px;
          font-weight: 700;
          color: #ffffff;
          margin-bottom: 16px;
        }

        .coming-soon-text {
          font-family: 'Poppins', sans-serif;
          font-size: 24px;
          font-weight: 600;
          color: #f46c38;
          margin-bottom: 12px;
          text-transform: uppercase;
          letter-spacing: 4px;
        }

        .coming-soon-description {
          font-family: 'Poppins', sans-serif;
          font-size: 16px;
          color: #998f8f;
          max-width: 400px;
        }

        @media (max-width: 768px) {
          .videography-page {
            padding: 20px 16px;
          }

          .videography-container {
            min-height: calc(100vh - 40px);
          }

          .back-link {
            margin-bottom: 24px;
          }

          .coming-soon-icon {
            font-size: 60px;
          }

          .page-title {
            font-size: 32px;
          }

          .coming-soon-text {
            font-size: 18px;
            letter-spacing: 3px;
          }

          .coming-soon-description {
            font-size: 14px;
          }
        }
      `}</style>
    </div>
  );
};

export default VideographyPage;
